import { mapKeys,isArray } from 'lodash';
declare global {
  interface Array<T> {
      inArray(comparer: Comparer): Boolean;
      pushIfNotExist(elem: any, comparer: Comparer): void;
  }
}

interface FlattenObject {
  flattenedValues: Array<any>;
  emptyObjectCheck: Array<any>;
}


if (!Array.prototype.inArray) {
  Array.prototype.inArray = function (comparer: Comparer) {
      const foundedElement = this.find(e => comparer(e));
      return !!foundedElement;
  };
}


if (!Array.prototype.pushIfNotExist) {
  Array.prototype.pushIfNotExist = function (element: any, comparer: Comparer) {
      if (!this.inArray(comparer)) {
          this.push(element);
      }
  };
}

export type Comparer = (e: any) => Boolean;

/**
* @param obj
* @param checkingValues
* Checking the condition of the whether the passed All of the Values are empty or undefined or null or "".
* If all of the flattened Object is empty or undefined or null it will return true,
* else it will start validates based on the checkingvalues & empty object check condition
*  If obj = {} it will return true.
*/
const flattenObject = (obj: any, checkingValues: Array<any> = [], ): boolean => {
  const flattenR = (
    nestedObj: any,
    checkedState: {
      valuesAsKeys: { [key: string]: boolean; }
      isPrimitiveFound: boolean;
    } = {
      valuesAsKeys: { },
      isPrimitiveFound: false,
    }
  ) => {
    return Object.keys(nestedObj || { }).reduce((accum, key) => {
      if (key) {
        if (typeof nestedObj[key] === 'object') {
          flattenR(nestedObj[key], accum);
        }
        else {
          accum.valuesAsKeys[nestedObj[key]] = true;
          accum.isPrimitiveFound = true;
        }
      }
      return accum;
    }, checkedState);
  };

  const checkedState = flattenR(obj);
  return checkedState.isPrimitiveFound ?
    // no values that are not included in checkingValues were found
    !Object.keys(checkedState.valuesAsKeys).find(value => !checkingValues.includes(value)) :
    // no "empty" values were found
    !Object.keys(checkedState.valuesAsKeys).find(value => !value || Object.keys(value).length === 0);
};

export const ValidationLogic = (obj: any, checkingValues: Array<any>) => {
  if (obj) {
    return flattenObject(obj, checkingValues);
  }
  else { return true; }
};


export const arrayKeyRenaming =  (items:any,keyMap:object) =>  {
if(isArray(items))
  return items.map(function(obj) {
    return mapKeys(obj, function(value, key) {
      return keyMap[key]?keyMap[key]:key
    });
  });
    return mapKeys(items, function(value, key) {
      return keyMap[key]?keyMap[key]:key
    });

}


